import React, {useCallback, useEffect, useMemo, useState} from 'react';
import DataGrid, {Column} from 'devextreme-react/data-grid';
import {Item as TabItem} from "devextreme-react/tab-panel";
import Form, {GroupItem, SimpleItem, Label} from "devextreme-react/form";
import IClient from "../../models/IClient";
import {FormListBase, FormListBaseTab, FormListBaseGrid} from '../base';
import {Button, TextBox} from 'devextreme-react';
import useCustomDataSource, {Mode} from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';

export default function GestionMontantsDus() {
    const clientFormDataSource = useCustomDataSource<IClient, IClient>({path: "client", primaryKey: "idClient", customReadAllPath: "client/read-list"});
    const {selectedDataRow: selectedClient, mode, setMode, isFieldModifier, setIsFieldModifier} = clientFormDataSource;
    const sources = ["Dépôts de réservations dûs", "Factures dûes"];
    const documents = ["Imprimante", "Courriel", "Imprimante et courriel"];
    const messages = ["Aucun"];

    const {sourceOptions, preleverPaiementOptions, rafraichirListeOptions, documentsOptions, messageOptions} = useMemo(() => {
        return {
            sourceOptions: {items: sources, layout: "horizontal"},
            preleverPaiementOptions: {text: "Prélever les paiements"},
            rafraichirListeOptions: {text: "Rafraîchir la liste"},
            documentsOptions: {items: documents, layout: "horizontal"},
            messageOptions: {items: messages}
        };
    }, []);

    return (
        <FormListBase data={clientFormDataSource}>
            <FormListBaseGrid dataSource={clientFormDataSource.dataSource}>
                <Column key={"grid-col-nom"} dataField={"nom"} caption="Nom" allowHiding={false}/>
                <Column key={"grid-col-prenom"} dataField={"prenom"} caption="Prénom" allowHiding={false}/>
                <Column key={"grid-col-adresse"} dataField={"adresse"} caption="Adresse" allowHiding={false}/>
            </FormListBaseGrid>
            <FormListBaseTab>
                <TabItem title="Informations">
                    <div style={{display: "flex"}}>
                        <div style={{width: "50%"}}>
                            <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedClient || {} as IClient} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
                                <GroupItem caption={"Informations du client"}>
                                    <SimpleItem key={"frm-nom"}>
                                        <Label text={"Nom"}/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-adresse"}>
                                        <Label text={"Adresse"}/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-ville"}>
                                        <Label text={"Ville"}/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-province"}>
                                        <Label text={"Province"}/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-pays"}>
                                        <Label text={"Pays"}/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-code-postal"}>
                                        <Label text={"Code postal"}/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-telephone"}>
                                        <Label text={"Téléphone"}/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-courriel"}>
                                        <Label text={"Courriel"}/>
                                    </SimpleItem>
                                </GroupItem>
                            </Form>
                        </div>
                        <div style={{width: "50%"}}>
                            <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedClient || {} as IClient} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
                                <GroupItem caption={"Options de prélèvement"}>
                                    <SimpleItem key={"frm-btn-prelever-paiements"}
                                                editorOptions={
                                                    preleverPaiementOptions
                                                }/>
                                    <SimpleItem key={"frm-rafraichir-liste"}
                                                editorOptions={
                                                    rafraichirListeOptions
                                                }/>
                                </GroupItem>
                            </Form>
                        </div>
                    </div>
                    <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedClient || {} as IClient} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
                        <GroupItem caption={"Liste des montants dûs"}>
                            <SimpleItem key={"frm-source"} dataField={"source"} editorType={"dxRadioGroup"}
                                        editorOptions={
                                            sourceOptions
                                        }/>
                            <SimpleItem key={"frm-documents"} dataField={"documents"} editorType={"dxRadioGroup"}
                                        editorOptions={
                                            documentsOptions
                                        }/>
                            <SimpleItem key={"frm-message"} dataField={""} editorType={"dxSelectBox"}
                                        editorOptions={
                                            messageOptions
                                        }
                            >
                                <Label text={"Message à utiliser sur les documents"}/>
                            </SimpleItem>
                            <SimpleItem key={"b1"}>
                <span style={{marginRight: "1em"}}>
                  <Button text={"Sélectionner clients avec email"}/>
                </span>
                                <span style={{marginRight: "1em"}}>
                  <Button text={"Sélectionner clients sans email"}/>
                </span>
                                <Button text={"Désélectionner tout"}/>
                            </SimpleItem>
                            <GroupItem>
                                <DataGrid showBorders={true} allowColumnResizing={true}>
                                    <Column caption={"No. confirmation"} dataType={"string"}/>
                                    <Column caption={"Date du délai"} dataType={"string"}/>
                                    <Column caption={"Client"} dataType={"string"}/>
                                    <Column caption={"No. dépôt"} dataType={"string"}/>
                                    <Column caption={"Montant dépôt restant"} dataType={"string"}/>
                                    <Column caption={"Montant dépôt reçu"} dataType={"string"}/>
                                    <Column caption={"Montant total réservation"} dataType={"string"}/>
                                    <Column caption={"Courriel"} dataType={"string"}/>
                                    <Column caption={"Sélectionner"} dataType={"string"}/>
                                </DataGrid>
                            </GroupItem>
                            <SimpleItem key={"frm-prix-total"}>
                                <div style={{display: "flex", justifyContent: "center"}}>
                                    <TextBox width={"25%"} readOnly={true}/>
                                </div>
                            </SimpleItem>
                        </GroupItem>
                    </Form>
                </TabItem>
                <TabItem title="Système"><FormSysteme formData={selectedClient || {} as IClient}/></TabItem>
            </FormListBaseTab>
        </FormListBase>
    );
}
